import { Component } from '@angular/core';
import { NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ApigeeService } from 'src/app/auth/apigee/apigee.service';

@Component({
    selector: 'page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    standalone: false
})
export class PageNotFoundComponent {
    constructor(private zone: NgZone, private router: Router,
        private apigeeService: ApigeeService) {
    }

    public async ngOnInit(): Promise<void> {
        try {
            await this.checkAuth();
        } catch (error) {
            this.router.navigate(['login']);
            return;
        }
    }

    private async checkAuth(): Promise<void> {
        if (this.apigeeService.apiToken == null) {
            if (this.apigeeService.googleAuthToken == null || this.apigeeService.googleDirectoryToken == null) {
                throw new Error("No credentials present");
            } else {
                throw new Error("Request token required");
            }
        }
    }
}
